import styled from '@emotion/styled';

export const SectionContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing.md};
`;
